module.exports = __webpack_public_path__ + "img/ryzs17.3a0f302f.jpg";